export enum UploadStatus {
  COMBINED_DATA_FILE = 'Combined data file',
  ENCOUNTER_LEVEL_DATA_FILE = 'Encounter-level data file',
  LAB_RESULTS_DATA_FILE = 'Lab results data file',
  MAPPING_TO_DATABASE = 'Mapping to database',
}
